import * as React from "react";

function SvgWave2(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path className="wave-2_svg__st2" d="M1432.2 67.4c-88.8-16.7-156-5.3-204 8.5s-147.1 62.2-223.1 73.9c-75.4 11.6-164-7.5-275-27.9S571 88.1 456 98.1c-119.7 10.4-224.7 52-294.4 73-94.5 28.5-171.6-3-171.6-3V210h1620V91.6c-53 10-86.8-7.1-177.8-24.2z" /></svg>;
}

export default SvgWave2;